export default (type) => [
  'function',
  'edgeFunction',
  'dockerTask',
  'stateMachine',
  'website'
].includes(type);
